import { OAUTH_PROVIDERS } from '../../shared/oauth-config';
const PENDING_OAUTH_STATE_KEY_PREFIX = 'anchor.native.oauthState.v1';
export const makeOAuthStateStorage = (storage)=>{
    const stateKey = (provider)=>"".concat(PENDING_OAUTH_STATE_KEY_PREFIX, ".").concat(provider);
    const readPendingState = (provider)=>storage.getItem(stateKey(provider));
    return {
        persistPendingState: (provider, state)=>storage.setItem(stateKey(provider), state),
        readPendingState,
        clearPendingState: (provider)=>storage.removeItem(stateKey(provider)),
        isAnyPending: ()=>OAUTH_PROVIDERS.some((provider)=>readPendingState(provider) != null)
    };
};
export const hasPendingOAuthSignIn = (storage)=>makeOAuthStateStorage(storage).isAnyPending();
